import styled from "styled-components";

export const SvgWrap = styled.span`
  white-space: nowrap;
  justify-content: space-between;
  display: flex;
  width: 60px;

  svg {
    fill: ${props => props.theme.colors.textPrimary};
  }
`;

export const SvgWrapArrow = styled.span`
  white-space: nowrap;
  justify-content: space-between;
  display: flex;
  width: 10px;
  cursor: pointer;
  svg {
    fill: ${props => props.theme.colors.textPrimary};
  }
`;
